import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";
import moment from "moment";

const slice = createSlice({
  name: "chats",
  initialState: {
    chatData: [],
    lastAppointment: {},
    loading: false,
    unreadMessage: false,
    unreadPatientIds: [],
    showUnreadDot: false,
  },
  reducers: {

    chatReceivedAll: (chats, action) => {
      // console.log("chat --------> ", action)
      chats.chatData = action.payload;
      chats.unreadMessage = true
    },
    chatDataRequested: (chats) => {
      chats.chatData = [];
      chats.loading = true;
    },
    chatDataReceived: (chats, action) => {
      chats.loading = false;
      // chats.chatData = action.payload.data;
      console.log("action.payload.lastAppointment --------> ", action.payload.lastAppointment)
      chats.lastAppointment = action.payload.lastAppointment
        ? action.payload.lastAppointment
        : {};
    },
    chatDataRequestFailed: (chats) => {
      chats.loading = false;
    },
    unreadUpdated: (chats, action) => {
      chats.unreadPatientIds =
        action.payload.unreadPatientIds;

      chats.showUnreadDot =
        action.payload.unreadPatientIds.length > 0;
    },
  },
});

export const {
  chatReceived,
  chatReceivedAll,
  chatDataRequested,
  chatDataReceived,
  chatDataRequestFailed,
  unreadUpdated,
} = slice.actions;
export default slice.reducer;

// // Action Creators
const url = "chat/";

export const loadChatForPatient = (id) => (dispatch, getState) => {
  return dispatch(
    apiCallBegan({
      url: url + "patient/" + id,
      onStart: chatDataRequested.type,
      onSuccess: chatDataReceived.type,
      onError: chatDataRequestFailed.type,
    })
  );
};

export const loadChatForDoctor = (id) => (dispatch, getState) => {
  return dispatch(
    apiCallBegan({
      url: url + "doctor/" + id,
      onStart: chatDataRequested.type,
      onSuccess: chatDataReceived.type,
      onError: chatDataRequestFailed.type,
    })
  );
};

export const getChats = createSelector(
  (state) => state.entities.chats,
  (chats) => chats
);
